export const handleApiError = (error, logout, navigate) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    if (error.response.status === 401) {
      // Unauthorized, handle session expiration
      logout(() => navigate("/login"));
    } else {
      // Other errors, log the message
      console.error("Request failed:", error.response.data.message || error.message);
    }
  } else if (error.request) {
    // The request was made but no response was received
    console.error("No response from server:", error.message);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error("Request error:", error.message);
  }
}